import { Grid } from "@material-ui/core";
import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import { useAnuncio } from "../../../../context/AnuncioContext";

export default function DetalleCupon() {
    const { anuncioSeleccionado, modalOpenDetalleAnuncio, handleOpenDetalleAnuncio } = useAnuncio();

    return (
        <MeditocModal
            size="small"
            title="Detalle del anuncio"
            open={modalOpenDetalleAnuncio}
            setopen={handleOpenDetalleAnuncio}
            okmessage="Cerrar detalle"
            hidecancel
        >
            <Grid container spacing={3}>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="ID de anuncio" value={anuncioSeleccionado.iIdAnuncio} />
                </Grid>
                <Grid item xs={12} className="center">
                    <img alt="FotoBanner" src={`${anuncioSeleccionado.sRutaWeb}`} className="foto-colaborador" />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Categoria del anuncio:" value={anuncioSeleccionado.sNombreCatAnuncio} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Fecha Inicio:" value={anuncioSeleccionado.sFechaInicio} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Fecha Vencimiento:" value={anuncioSeleccionado.sFechaVencimiento} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Duración en segundo(s):" value={anuncioSeleccionado.iDuracion} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Fecha de creación:" value={anuncioSeleccionado.sFechaCreacion} />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
